import {
    MODAL_EXIT_ACTIVE,
    MODAL_EXIT_SHOW
} from "../types/modalExit";

const initialState = {
    active: false,
    show: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case MODAL_EXIT_ACTIVE:
            return {
                ...state,
                active: action.data,
            };
        case MODAL_EXIT_SHOW:
            return {
                ...state,
                show: action.data,
            };
        default:
            return state;
    }
};
